// extracted by mini-css-extract-plugin
export var banner = "_1r-0";
export var icon = "_1r-1";
export var message = "_1r-2";